import './StatusBadge.css';

const STATUS_MAP = {
  'non analysé': { label: 'En analyse', color: 'blue', icon: '🔎' },
  'analysé': { label: 'En analyse', color: 'blue', icon: '🔎' },
  'en analyse': { label: 'En analyse', color: 'blue', icon: '🔎' },
  'validé': { label: 'Validé', color: 'green', icon: '✅' },
  'en révision': { label: 'En révision', color: 'orange', icon: '🔄' },
  'en attente': { label: 'En attente', color: 'gray', icon: '⏳' },
  'rejeté': { label: 'Refusé', color: 'red', icon: '❌' },
  'non approuvé': { label: 'Refusé', color: 'red', icon: '❌' },
  'non validé': { label: 'Non validé', color: 'red', icon: '❌' },
};

export default function StatusBadge({ status }) {
  const config = STATUS_MAP[status?.toLowerCase()] || {
    label: status || 'Inconnu',
    color: 'gray',
    icon: '•',
  };

  return (
    <span className={`status-badge ${config.color}`}>
      <span className="icon">{config.icon}</span>
      {config.label}
    </span>
  );
}
